import { useId, useLayoutEffect } from "react";

import { useCircleAIShellStore } from "../store/circleAIShellStore";
import type { DockMode } from "../types";

interface UseDockOptions {
  enabled?: boolean;
  mode?: DockMode;
}

export const useDock = ({ enabled = true, mode }: UseDockOptions = {}) => {
  const id = useId();
  const pushDockOverride = useCircleAIShellStore(s => s.pushDockOverride);
  const popDockOverride = useCircleAIShellStore(s => s.popDockOverride);
  const activeMode = enabled ? mode : undefined;

  useLayoutEffect(() => {
    if (activeMode) {
      pushDockOverride(id, activeMode);
    } else {
      popDockOverride(id);
    }
  }, [activeMode, id, pushDockOverride, popDockOverride]);

  useLayoutEffect(() => () => popDockOverride(id), [id, popDockOverride]);
};
